import React, { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import FastImage from 'utils/packages/rnFastImage';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { Button, hitSlop, IconClose, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import Collapsible from 'utils/packages/rnCollapsible';
import { YEARLY_REPORT_FEED, YEARLY_REPORT_YEAR, } from 'actions/deviceSettingTypes';
import { isWeb } from '../../../../constants';
const yearlyReportImage = require('../../img/2025_yearly_report_feed.png');
const gradientColors = ['#574FFB', '#9039F9'];
const YearlyReportBanner = ({ data, openReport, isDismissible, containerStyle, withFrame, }) => {
    const styles = useStyles(styleSet);
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const dispatch = useAppDispatch();
    const handleStartReport = useCallback(() => {
        openReport({ ...data, type: 'YEARLY' });
    }, [data, openReport]);
    const didDismissYearlyReportFeed = useAppSelector((store) => store.deviceSettings[YEARLY_REPORT_FEED]);
    const handleDismissReport = useCallback(() => {
        dispatch(setDeviceSettingsKey(YEARLY_REPORT_FEED, true));
    }, []);
    return (<Collapsible style={!!withFrame && paddingHorizontalStyle} collapsed={Boolean(isDismissible && didDismissYearlyReportFeed)}>
      <LinearGradient colors={gradientColors} angle={102} useAngle style={[styles.container, containerStyle]}>
        <FastImage source={yearlyReportImage} resizeMode="contain" style={styles.image}/>
        <Text Text-16 White>
          Your yearly report is ready!
        </Text>
        <Spacer.H4 />
        <Text TextThin-14 White>
          {`See what you can${isWeb ? ' ' : '\n'}improve${isWeb ? '\n' : ' '}in ${YEARLY_REPORT_YEAR + 1}!`}
        </Text>
        <Spacer h={20}/>
        <Button brandLight square hug title="Start the report" onPress={handleStartReport} containerStyle={styles.button}/>
        {!!isDismissible && (<TouchableOpacity onPress={handleDismissReport} style={styles.dismissButton} hitSlop={hitSlop}>
            <IconClose alt/>
          </TouchableOpacity>)}
      </LinearGradient>
    </Collapsible>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginHorizontal: rem(16),
        marginBottom: rem(16),
        padding: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
        overflow: 'hidden',
    },
    image: {
        position: 'absolute',
        right: -rem(9),
        width: rem(216),
        height: rem(156),
    },
    button: {
        alignSelf: 'flex-start',
    },
    dismissButton: {
        position: 'absolute',
        top: rem(8),
        right: rem(8),
        width: rem(24),
        height: rem(24),
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
    },
}));
export default memo(YearlyReportBanner);
